import { render, staticRenderFns } from "./PurposeOfMeet.vue?vue&type=template&id=389982e1&"
import script from "./PurposeOfMeet.vue?vue&type=script&lang=js&"
export * from "./PurposeOfMeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports